export default "<canvas #canvas></canvas>";